
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axios/axiosInstance";
import { setResultModalData, showModal } from "../modal/modalSlice";
import moment from "moment";
import { menuOptions, sendOptions, subMenuOptions } from "../../utils/bildirimOptions";

const initialState = {

    allMobileNotificationHistoryCount: 0,
    isLoadingGetAllMobileNotificationHistory: false,
    allMobileNotificationHistoryList: [],
    
    
    specificMobileNotificationHistoryCount: 0,
    isLoadingGetSpecificMobileNotificationHistory: false,
    specificMobileNotificationHistoryList: [],


    allPanelNotificationHistoryCount: 0,
    isLoadingGetAllPanelNotificationHistory: false,
    allPanelNotificationHistoryList: [],
    
    
    specificPanelNotificationHistoryCount: 0,
    isLoadingGetSpecificPanelNotificationHistory: false,
    specificPanelNotificationHistoryList: [],

    //! uetds bildirimleri
    uetdsNotificationList: [],
    isLoadingUetdsNotificationList: false,
    uetdsNotificationCount: 0,
    selectedUetdsNotification: null,
    
    //! notification (mobil)

    isLoadingGetPhoneNumberForNotification: false,
    isLoadingSendNotificationSpecific: false,
    isLoadingSendNotification: false,
    phoneNumbersForNotification: [],

    notificationActiveTab: 1,

    notificationTitle: "",
    notificationText: "",

    notificationMenu: {
      id: "",
      text: "",
      value: ""
    },

    notificationSubMenu: {
      id: "",
      text: "",
      value: ""
    },

    mobileNotification: false,

    selectedPhoneNumbers: [],


    //! notification (portal)

    isLoadingSendPortalNotificationAll: false,
    isLoadingSendPortalNotificationSpecific: false,

    // phoneNumbersForNotification: [],

    notificationActiveTabPortal: 1,

    notificationTitlePortal: "",
    notificationTextPortal: "",

    notificationMenuPortal: {
      id: 0,
      text: "",
      value: "",
      subMenus: []
    },

    notificationSubMenuPortal: {
      id: 0,
      text: "",
      value: ""
    },

    selectedCompanyList: [],


    //! planlı *************************************************

  isLoadingGetScheduledNotifications: false,
  scheduledNotificationList: [],

  notificationSendType: {
    id:null,
    text: ""
  },
  
  monthDay: "",

  timeData: {
    hour: "",
    minute: ""
  },

  isLastDayOfMonthAccepted: false,

  //! 1. 31 çekmeyen aylar, 2. 30 bile çekemeyen şubat

  monthDayWarningType: 0,

  weekDayItem: {
    id: null,
    text: ""
  },


  targetDate: "",

  isLoadingSendRegularMonthlyNotification: false,

  isLoadingSendRegularWeeklyNotification: false,

  isLoadingSendTargetDateNotification: false,

  scheduledNotificationItemData: null,

  isLoadingDeleteScheduledNotification: false


};
    
export const getAllMobileNotificationHistory = createAsyncThunk("admin4/GetAllMobileNotificationHistory",async ({page}, thunkApi) => {
  try {
    const { data } = await axiosInstance.get(`/Notifications/GetAllNotificationHistory?page=${page}`);
    
    return data;
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});

  
export const getSpecificMobileNotificationHistory = createAsyncThunk("admin4/getSpecificMobileNotificationHistory",async ({page}, thunkApi) => {
  try {
    const { data } = await axiosInstance.get(`/Notifications/GetAllSpecificNotificationHistory?page=${page}`);
    
    return data;
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});

export const getAllPanelNotificationHistory = createAsyncThunk("admin4/getAllPanelNotificationHistory",async ({page}, thunkApi) => {
  try {
    const { data } = await axiosInstance.get(`/WebNotifications/GetAllWebNotificationHistory?page=${page}`);
    
    return data;
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});

  
export const getSpecificPanelNotificationHistory = createAsyncThunk("admin4/getSpecificPanelNotificationHistory",async ({page}, thunkApi) => {
  try {
    const { data } = await axiosInstance.get(`/WebNotifications/GetAllWebSpecificNotificationHistory?page=${page}`);
    
    return data;
  } catch (error) {
    return thunkApi.rejectWithValue(error);
    }
});
  

//! uetds bildirimleri
export const getAllUetdsNotification = createAsyncThunk("admin4/getAllUetdsNotification",async ({page, type = "", driverName = "", notificationStatus = "", isDriverCalled = "", phoneNumber = ""}, thunkApi) => {
  try {
    const { data } = await axiosInstance.get(`/UETDS/GetAllUetdsNotification?page=${page}&type=${type}&driverName=${driverName}&notificationStatus=${notificationStatus}&isDriverCalled=${isDriverCalled}&phoneNumber=${phoneNumber}`);
    
    return data.data;
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});

export const UETDSNotificationDriverCalled = createAsyncThunk("admin4/UETDSNotificationDriverCalled",async (body, thunkApi) => {
  try {
    const { data } = await axiosInstance.post(`/UETDS/UETDSNotificationDriverCalled`, body);
    if (data) {
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(
        setResultModalData({
          msg: "Başarılı bir şekilde güncellendi.",
          resultType: "success",
          btnText1: "Listeyi Görüntüle",
        })
      );
    }
    return data.data;
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});


export const sendNotification = createAsyncThunk("admin4/sendNotification", async(notificationData, thunkApi)=> {
  try {
        
      const {data} = await axiosInstance.post(`/user/SendAllClintNotify`, notificationData)
      if(data.statusCode === 200){
          thunkApi.dispatch(showModal("result"))
          thunkApi.dispatch(setResultModalData({msg: "Bildirim Başarıyla Gönderildi.", resultType: "success",  btnText1: "Mükemmel"}))
      }
      return data
  } catch (error) {
      thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
      return thunkApi.rejectWithValue(error)
  }
})

export const sendNotificationSpesific = createAsyncThunk("admin4/sendNotificationSpesific", async(notificationData, thunkApi)=> {
  try {
      
      const {data} = await axiosInstance.post(`/user/SendSomeClientSendNotify`, notificationData)
      if(data.statusCode === 200){
          thunkApi.dispatch(showModal("result"))
          thunkApi.dispatch(setResultModalData({msg: "Bildirim Başarıyla Gönderildi.", resultType: "success",  btnText1: "Mükemmel"}))
      }
      return data
  } catch (error) {
      thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
      return thunkApi.rejectWithValue(error)
  }
})

export const getPhoneNumberForNotification = createAsyncThunk("admin4/getPhoneNumberForNotification", async(phoneNumber, thunkApi)=> {
  try {
      
      const {data} = await axiosInstance.get(`/user/GetUserNameAndPhoneNumberForNotifiyPage?phoneNumber=${phoneNumber}`)
      
      return data
  } catch (error) {
      return thunkApi.rejectWithValue(error)
  }
})


export const getScheduledNotifications = createAsyncThunk("admin4/getScheduledNotifications", async({page, isRegularType}, thunkApi)=> {
  try {
      //! filter
      //! IsRegularType 
      //! CompanyName 
      const {data} = await axiosInstance.get(`/ScheduledNotifications/GetAllMobileScheduledNotification?page=${page}&&isRegularType=${isRegularType}`)
      
      return data
  } catch (error) {
      return thunkApi.rejectWithValue(error)
  }
})

export const sendTargetDateNotification = createAsyncThunk("admin4/sendTargetDateNotification", async(notificationData, thunkApi)=> {
  try {
    
      const {data} = await axiosInstance.post(`/ScheduledNotifications/SendTargetDateNotification`, notificationData)
      if (data.statusCode === 200) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(setResultModalData({ msg: "Bildirim Planlama başarıyla oluşturuldu.", resultType: "success", btnText1: "Listeyi Görüntüle",}));
      }
      else{
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
      }
      
      return data
  } catch (error) {
      return thunkApi.rejectWithValue(error)
  }
})

export const sendRegularWeeklyNotification = createAsyncThunk("admin4/sendRegularWeeklyNotification", async(notificationData, thunkApi)=> {
  try {
    
      const {data} = await axiosInstance.post(`/ScheduledNotifications/SendRegularWeeklyNotification`, notificationData)
      if (data.statusCode === 200) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(setResultModalData({ msg: "Bildirim Planlama başarıyla oluşturuldu.", resultType: "success", btnText1: "Listeyi Görüntüle",}));
      }
      else{
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
      }
      return data
  } catch (error) {
      return thunkApi.rejectWithValue(error)
  }
})

export const sendRegularMonthlyNotification = createAsyncThunk("admin4/sendRegularMonthlyNotification", async(notificationData, thunkApi)=> {
  try {
    
      const {data} = await axiosInstance.post(`/ScheduledNotifications/SendRegularMonthlyNotification`, notificationData)
      if (data.statusCode === 200) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(setResultModalData({ msg: "Bildirim Planlama başarıyla oluşturuldu.", resultType: "success", btnText1: "Listeyi Görüntüle",}));
      }
      else{
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
      }
      return data
  } catch (error) {
      return thunkApi.rejectWithValue(error)
  }
})


//! burası kullanılmıyor
export const updateScheduledNotification = createAsyncThunk("admin4/updateScheduledNotification", async(notificationData, thunkApi)=> {
  try {
      //! filter
      //! IsRegularType
      //! CompanyName
      const {data} = await axiosInstance.post(`/ScheduledNotifications/UpdateScheduledNotification`, notificationData)
      
      return data
  } catch (error) {
      return thunkApi.rejectWithValue(error)
  }
})


export const deleteScheduledNotification = createAsyncThunk("admin4/deleteScheduledNotification", async(notificationId, thunkApi)=> {
  try {
      
      const {data} = await axiosInstance.delete(`/ScheduledNotifications/DeleteScheduledNotification?id=${notificationId}`)
      
      return data
  } catch (error) {
      return thunkApi.rejectWithValue(error)
  }
})






  //! tüm portal kullanıcılarına bildirim gönder
  export const sendPortalNotificationAll = createAsyncThunk("admin4/sendPortalNotificationAll",async (body, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/WebNotifications/SendNotificationToAllClient`, body);
      if (data) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Bildirim gönderildi.",
            resultType: "success",
            btnText1: "Tamam",
          })
        );
    }
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });

  //! seçili portal kullanıcılarına bildirim gönder
  export const sendPortalNotificationSpecific = createAsyncThunk("admin4/sendPortalNotificationSpecific",async (body, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/WebNotifications/SendNotificationToClient`, body);
      if (data) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Bildirim gönderildi.",
            resultType: "success",
            btnText1: "Tamam",
          })
        );
    }
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });
 

const admin4Slice = createSlice({
  name: "admin4",
  initialState,
  reducers: {
    setSelectedUetdsNotification: (state, action) => {
      state.selectedUetdsNotification = action.payload
    },

    //! notification Mobile
    setNotificationActiveTab: (state,action) => {
      state.notificationActiveTab = action.payload
    },

    setNotificationTitle: (state, action) => {
      state.notificationTitle = action.payload
    },

    setNotificationText: (state, action) => {
      state.notificationText = action.payload
    },

    setNotificationMenu: (state, action) => {

      if(action.payload.pastNotificationMenu !== action.payload.item){
        state.notificationSubMenu = {
          id: "",
          text: "",
          value: ""
        }
        state.notificationMenu = action.payload.item
      }
    },

    setNotificationSubMenu: (state, action) => {
      state.notificationSubMenu = action.payload
    },

    setMobileNotification: (state,action) => {
      state.mobileNotification = action.payload
    },

    setNotificationHistoryItemToFilled: (state, action) => {

      const {
        notificationTitle,
        notificationText,
        notificationMenu,
        notificationSubMenu,
      } = action.payload


      state.notificationTitle = notificationTitle 
      state.notificationText = notificationText 
      state.notificationMenu = notificationMenu 
      state.notificationSubMenu = notificationSubMenu 

    },

    setNotificationHistoryItemToFilledSpecific: (state, action) => {
      
      const {
        notificationTitle,
        notificationText,
        notificationMenu,
        notificationSubMenu,
        selectedPhoneNumbers
      } = action.payload
      

      state.notificationTitle = notificationTitle 
      state.notificationText = notificationText 
      state.notificationMenu = notificationMenu 
      state.notificationSubMenu = notificationSubMenu 
      state.selectedPhoneNumbers = selectedPhoneNumbers
    },

    setSelectedPhoneNumbers: (state,action) => {
      state.selectedPhoneNumbers = action.payload
    },

    clearNotificationForm: (state) => {
      state.isLoadingGetPhoneNumberForNotification = false
      state.isLoadingSendNotificationSpecific = false
      state.isLoadingSendNotification = false
      state.phoneNumbersForNotification = []

      state.notificationTitle = ""
      state.notificationText = ""

      state.notificationMenu = {
        id: "",
        text: "",
        value: ""
      }
  
      state.notificationSubMenu = {
        id: "",
        text: "",
        value: ""
      }
  
      state.mobileNotification= false
      state.selectedPhoneNumbers= []
    },


    //! notification portal
    setNotificationActiveTabPortal: (state,action) => {
      
      state.notificationActiveTabPortal = action.payload
    },

    setNotificationTitlePortal: (state, action) => {
      state.notificationTitlePortal = action.payload
    },

    setNotificationTextPortal: (state, action) => {
      state.notificationTextPortal = action.payload
    },

    setNotificationMenuPortal: (state, action) => {
      
      if(action.payload.pastNotificationMenuPortal !== action.payload.item){
        state.notificationSubMenu = {
          id: "",
          text: "",
          value: ""
        }
      state.notificationMenuPortal = action.payload.item

      }
    },

    setNotificationSubMenuPortal: (state, action) => {
      state.notificationSubMenuPortal = action.payload
    },

    setSelectedCompanyList: (state, action) => {
      state.selectedCompanyList = action.payload
    },


    setNotificationHistoryItemToFilledPortal: (state, action) => {

      const {
        notificationTitlePortal,
        notificationTextPortal,
        notificationMenuPortal,
        notificationSubMenuPortal,
      } = action.payload


      state.notificationTitlePortal = notificationTitlePortal 
      state.notificationTextPortal = notificationTextPortal
      state.notificationMenuPortal = notificationMenuPortal
      state.notificationSubMenuPortal = notificationSubMenuPortal
    },

    setNotificationHistoryItemToFilledSpecificPortal: (state, action) => {
      
      const {
        notificationTitlePortal,
        notificationTextPortal,
        notificationMenuPortal,
        notificationSubMenuPortal,
        selectedCompanyList
      } = action.payload

      
      state.notificationTitlePortal = notificationTitlePortal 
      state.notificationTextPortal = notificationTextPortal 
      state.notificationMenuPortal = notificationMenuPortal 
      state.notificationSubMenuPortal = notificationSubMenuPortal 
      state.selectedCompanyList = selectedCompanyList
    },

    clearNotificationPortalForm: (state) => {
      state.isLoadingSendPortalNotificationAll = false
      state.isLoadingSendPortalNotificationSpecific = false


      state.notificationTitlePortal = ""
      state.notificationTextPortal = ""

      state.notificationMenuPortal = {
        id: 0,
        text: "",
        value: "",
        subMenus: []
      }

      state.notificationSubMenuPortal = {
        id: 0,
        text: "",
        value: ""
      }

      state.selectedCompanyList = []
    },



    //! planlı *************************************************


    setNotificationSendType: (state,action) => {
      state.notificationSendType = action.payload
    },

    //! month day ini belirten planlı/aylıkta
    setMonthDay: (state,action) => {
      state.monthDay = action.payload

      

      if(action.payload > 28 && action.payload <= 30){
        state.monthDayWarningType = 2
      }

      else if(action.payload === 31){
        state.monthDayWarningType = 1
      }
    },

    setTimeData: (state,action) => {
      state.timeData = {...state.timeData, ...action.payload}
    },

    setIsLastDayOfMonthAccepted: (state, action) => {
      state.isLastDayOfMonthAccepted = action.payload
    },

    setWeekDayItem: (state,action) => {
      state.weekDayItem = action.payload
    },

    setTargetDate: (state,action) => {
      state.targetDate = action.payload
    },

    setScheduledNotificationItemData: (state,action) => {
      state.scheduledNotificationItemData = action.payload.data
      const {data, type} = action.payload
   
      //! burası update gerekirse duracak burada
      // if(type === "update"){
      //   state.notificationTitle = data.title
      //   state.notificationText = data.text
      //   state.notificationMenu = menuOptions.find(item => item.value === data.routeName)
      //   state.notificationSubMenu = subMenuOptions.find(item => item.value === data.screenName)
      //   state.selectedPhoneNumbers = data.scheduledNotificationRecipients.$values.map(item => {
      //     return {
      //       userName: item.userName,
      //       phoneNumber: item.phoneNumber
      //     }
      //   })
      //   state.notificationSendType = sendOptions.find(item => item.id === data.isRegularType)
        
      //   state.timeData = {
      //     hour: new Date(data.scheduledTime).getHours().toString().padStart(2, "0"),
      //     minute: new Date(data.scheduledTime).getMinutes().toString().padStart(2, "0")
      //   }
      //   state.targetDate = data?.scheduledTime?.split("T")[0]
      // }
    },

    clearPhoneNumbersForNotification: (state,action) => {
      state.phoneNumbersForNotification = []
    },

    clearScheduledData:(state) => {
      state.isLoadingGetScheduledNotifications = false
    
      state.monthDay = ""
    
      state.timeData= {
        hour: "",
        minute: ""
      }
    
      state.isLastDayOfMonthAccepted = false
    
      state.monthDayWarningType = 0
    
      state.weekDayItem = {
        id: null,
        text: ""
      }
    
      state.targetDate = ""
    
    }
    

  },
  extraReducers: (builder) => {
    builder

        //! getAllMobileNotificationHistory
        .addCase(getAllMobileNotificationHistory.pending, (state)=> {
          state.isLoadingGetAllMobileNotificationHistory = true
      })

      .addCase(getAllMobileNotificationHistory.fulfilled, (state, action)=> {
          state.isLoadingGetAllMobileNotificationHistory = false
          state.allMobileNotificationHistoryCount = action.payload.data.count
          const messageHistoryByDate = action.payload.data.items.$values.reduce((acc, message) => {
              const { createdAt, ...restOfMessage } = message;
              const group = acc.find(
                  (item) => moment(item.createdAt).format('L') === moment(createdAt).format('L')
              );
              if (!group) {
                  acc.push({
                      createdAt: createdAt,
                      data: [restOfMessage],
                  });
              } else {
                  group.data.push(restOfMessage);
              }
              return acc?.sort((a, b) => moment(b?.createdAt) - moment(a?.createdAt));
          }, []);
          state.allMobileNotificationHistoryList = messageHistoryByDate
      })

      .addCase(getAllMobileNotificationHistory.rejected, (state, action)=> {
          state.isLoadingGetAllMobileNotificationHistory = false
      })

      
      //! getSpecificMobileNotificationHistory
      .addCase(getSpecificMobileNotificationHistory.pending, (state)=> {
          state.isLoadingGetSpecificMobileNotificationHistory = true
      })

      .addCase(getSpecificMobileNotificationHistory.fulfilled, (state, action)=> {
          state.isLoadingGetSpecificMobileNotificationHistory = false
          state.specificMobileNotificationHistoryCount = action.payload.data.count
          const messageHistoryByDate = action.payload.data.items.$values.reduce((acc, message) => {
              const { createdAt, ...restOfMessage } = message;
              const group = acc.find(
                  (item) => moment(item.createdAt).format('L') === moment(createdAt).format('L')
              );
              if (!group) {
                  acc.push({
                      createdAt: createdAt,
                      data: [restOfMessage],
                  });
              } else {
                  group.data.push({...restOfMessage, createdAt});
              }
              return acc?.sort((a, b) => moment(b?.createdAt) - moment(a?.createdAt));
          }, []);
          state.specificMobileNotificationHistoryList = messageHistoryByDate

      })

      .addCase(getSpecificMobileNotificationHistory.rejected, (state, action)=> {
          state.isLoadingGetSpecificMobileNotificationHistory = false
      })


      
      //! getAllPanelNotificationHistory
      .addCase(getAllPanelNotificationHistory.pending, (state)=> {
          state.isLoadingGetAllPanelNotificationHistory = true
      })

      .addCase(getAllPanelNotificationHistory.fulfilled, (state, action)=> {
        state.isLoadingGetAllPanelNotificationHistory = false
        state.allPanelNotificationHistoryCount = action.payload.data.count
        const messageHistoryByDate = action.payload.data.items.$values.reduce((acc, message) => {
            const { createdAt, ...restOfMessage } = message;
            const group = acc.find(
                (item) => moment(item.createdAt).format('L') === moment(createdAt).format('L')
            );
            if (!group) {
                acc.push({
                    createdAt: createdAt,
                    data: [restOfMessage],
                });
            } else {
                group.data.push(restOfMessage);
            }
            return acc?.sort((a, b) => moment(b?.createdAt) - moment(a?.createdAt));
        }, []);
        state.allPanelNotificationHistoryList = messageHistoryByDate
      })

        .addCase(getAllPanelNotificationHistory.rejected, (state, action)=> {
            state.isLoadingGetAllPanelNotificationHistory = false
        })


        //! getSpecificPanelNotificationHistory
        .addCase(getSpecificPanelNotificationHistory.pending, (state)=> {
            state.isLoadingGetSpecificPanelNotificationHistory = true
        })

        .addCase(getSpecificPanelNotificationHistory.fulfilled, (state, action)=> {
            state.isLoadingGetSpecificPanelNotificationHistory = false
            state.specificPanelNotificationHistoryCount = action.payload.data.count
            const messageHistoryByDate = action.payload.data.items.$values.reduce((acc, message) => {
                const { createdAt, ...restOfMessage } = message;
                const group = acc.find(
                    (item) => moment(item.createdAt).format('L') === moment(createdAt).format('L')
                );
                if (!group) {
                    acc.push({
                        createdAt: createdAt,
                        data: [restOfMessage],
                    });
                } else {
                    group.data.push({...restOfMessage, createdAt});
                }
                return acc?.sort((a, b) => moment(b?.createdAt) - moment(a?.createdAt));
            }, []);
            state.specificPanelNotificationHistoryList = messageHistoryByDate
        })

        .addCase(getSpecificPanelNotificationHistory.rejected, (state, action)=> {
          state.isLoadingGetSpecificPanelNotificationHistory = false
        })

        //! uetds bildirimleri
        .addCase(getAllUetdsNotification.pending, (state)=> {
          state.isLoadingUetdsNotificationList = true
        })

        .addCase(getAllUetdsNotification.fulfilled, (state, action)=> {
          state.isLoadingUetdsNotificationList = false
          state.uetdsNotificationList = action.payload.items.$values
          state.uetdsNotificationCount = action.payload.count
        })

        .addCase(getAllUetdsNotification.rejected, (state, action)=> {
          state.isLoadingUetdsNotificationList = false
        })

        //! UETDSNotificationDriverCalled
        .addCase(UETDSNotificationDriverCalled.pending, (state)=> {
          state.isLoadingUetdsNotificationList = true
        })

        .addCase(UETDSNotificationDriverCalled.fulfilled, (state, action)=> {
          state.isLoadingUetdsNotificationList = false
          state.uetdsNotificationList = state.uetdsNotificationList.map((item) => {
            if (item.id === action.payload.id) {
              return action.payload
            }else{
              return item
            }
          })
        })

        .addCase(UETDSNotificationDriverCalled.rejected, (state, action)=> {
          state.isLoadingUetdsNotificationList = false
        })


        //! getPhoneNumberForNotification
        .addCase(getPhoneNumberForNotification.pending, (state)=> {
            state.isLoadingGetPhoneNumberForNotification = true
        })

        .addCase(getPhoneNumberForNotification.fulfilled, (state, action)=> {
            state.isLoadingGetPhoneNumberForNotification = false
            state.phoneNumbersForNotification = action.payload.data.$values
        })

        .addCase(getPhoneNumberForNotification.rejected, (state, action)=> {
            state.isLoadingGetPhoneNumberForNotification = false
        })


        
        //! sendTargetDateNotification
        .addCase(sendTargetDateNotification.pending, (state)=> {
          state.isLoadingSendTargetDateNotification = true
      })

      .addCase(sendTargetDateNotification.fulfilled, (state, action)=> {
          state.isLoadingSendTargetDateNotification = false
      })

      .addCase(sendTargetDateNotification.rejected, (state, action)=> {
          state.isLoadingSendTargetDateNotification = false
      })


        //! sendRegularWeeklyNotification
        .addCase(sendRegularWeeklyNotification.pending, (state)=> {
          state.isLoadingSendRegularWeeklyNotification = true
      })

      .addCase(sendRegularWeeklyNotification.fulfilled, (state, action)=> {
          state.isLoadingSendRegularWeeklyNotification = false
      })

      .addCase(sendRegularWeeklyNotification.rejected, (state, action)=> {
          state.isLoadingSendRegularWeeklyNotification = false
      })


      //! sendRegularMonthlyNotification
      .addCase(sendRegularMonthlyNotification.pending, (state)=> {
          state.isLoadingSendRegularMonthlyNotification = true
      })

      .addCase(sendRegularMonthlyNotification.fulfilled, (state, action)=> {
          state.isLoadingSendRegularMonthlyNotification = false
      })

      .addCase(sendRegularMonthlyNotification.rejected, (state, action)=> {
          state.isLoadingSendRegularMonthlyNotification = false
      })


        //! deleteScheduledNotification
        .addCase(deleteScheduledNotification.pending, (state)=> {
          state.isLoadingDeleteScheduledNotification = true
        })

        .addCase(deleteScheduledNotification.fulfilled, (state, action)=> {
          state.isLoadingDeleteScheduledNotification = false
          state.scheduledNotificationList = state.scheduledNotificationList.filter(item => {
            return item.id !== action.payload.data.id
          })
        })

        .addCase(deleteScheduledNotification.rejected, (state, action)=> {
          state.isLoadingDeleteScheduledNotification = false
        })


        //!  send notification
        .addCase(sendNotification.pending, (state)=> {
            state.isLoadingSendNotification = true
        })
    
        .addCase(sendNotification.fulfilled, (state, action)=> {
            state.isLoadingSendNotification = false
        })
    
        .addCase(sendNotification.rejected, (state, action)=> {
            state.isLoadingSendNotification = false
        })
    
        //!  sendNotificationSpesific
        .addCase(sendNotificationSpesific.pending, (state)=> {
            state.isLoadingSendNotificationSpecific = true
        })
    
        .addCase(sendNotificationSpesific.fulfilled, (state, action)=> {
            state.isLoadingSendNotificationSpecific = false
        })
    
        .addCase(sendNotificationSpesific.rejected, (state, action)=> {
            state.isLoadingSendNotificationSpecific = false
        })

        
        //! sendPortalNotificationAll
        .addCase(sendPortalNotificationAll.pending, (state)=> {
          state.isLoadingSendPortalNotificationAll = true
        })
        .addCase(sendPortalNotificationAll.fulfilled, (state, action)=> {
          state.isLoadingSendPortalNotificationAll = false
        })
        .addCase(sendPortalNotificationAll.rejected, (state, action)=> {
          state.isLoadingSendPortalNotificationAll = false
        })

        //! sendPortalNotificationSpecific
        .addCase(sendPortalNotificationSpecific.pending, (state)=> {
          state.isLoadingSendPortalNotificationSpecific = true
        })
        .addCase(sendPortalNotificationSpecific.fulfilled, (state, action)=> {
            state.isLoadingSendPortalNotificationSpecific = false
        })
        .addCase(sendPortalNotificationSpecific.rejected, (state, action)=> {
            state.isLoadingSendPortalNotificationSpecific = false
        })


        //! planlı *******************************************************************************

        //! getScheduledNotifications
        .addCase(getScheduledNotifications.pending, (state)=> {
          state.isLoadingGetScheduledNotifications = true
        })
        .addCase(getScheduledNotifications.fulfilled, (state, action)=> {
            state.isLoadingGetScheduledNotifications = false
            state.scheduledNotificationList = action.payload.data.items.$values
        })
        .addCase(getScheduledNotifications.rejected, (state, action)=> {
            state.isLoadingGetScheduledNotifications = false
        })
        

  },
});


export const {  
  setSelectedUetdsNotification,

  //! notification mobile
  setNotificationActiveTab,
  setNotificationTitle,
  setNotificationHistoryItemToFilled,
  setNotificationHistoryItemToFilledSpecific,
  setNotificationSubMenu,
  setNotificationText,
  setMobileNotification,
  setNotificationMenu,
  setSelectedPhoneNumbers,
  clearNotificationForm,

  //! notification portal
  setNotificationSubMenuPortal,
  setNotificationMenuPortal,
  setNotificationTextPortal,
  setNotificationTitlePortal,
  setNotificationActiveTabPortal,
  setSelectedCompanyList,

  setNotificationHistoryItemToFilledSpecificPortal,
  setNotificationHistoryItemToFilledPortal,
  clearNotificationPortalForm,

  //! month day ini belirten planlı/aylıkta
  setMonthDay,
  setTimeData,

  setNotificationSendType,

  setIsLastDayOfMonthAccepted,

  setWeekDayItem,

  setTargetDate,

  setScheduledNotificationItemData,

  clearPhoneNumbersForNotification,
  clearScheduledData


} = admin4Slice.actions;
export default admin4Slice.reducer;
